import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';
import moment from 'moment';

export default [
  {
    name: 'eventDateFrom',
    label: i18n('entities.event.fields.eventDateFrom'),
    render: (value) => value ? moment(value).format('YY/MM/DD') : value,
  },
  {
    name: 'eventDateTo',
    label: i18n('entities.event.fields.eventDateTo'),
    render: (value) => value ? moment(value).format('YY/MM/DD') : value,
  },
  {
    name: 'name',
    label: i18n('entities.event.fields.name'),
  },
  
  {
    name: 'eventVisibility',
    label: i18n('entities.event.fields.eventVisibility'),
  },
  {
    name: 'copiedTenants',
    label: i18n('entities.event.fields.copiedTenants'),
    render: (value) =>
      (value || []).map((tenant) => tenant.name).join(', '),
  },

  {
    name: 'updatedGlobalAt',
    label: i18n('entities.event.fields.updatedGlobalAt'),
    render: (value) => value ? moment(value).format('YY/MM/DD') : value,
  },

  {
    name: 'updatedGlobalBy',
    label: i18n('entities.event.fields.updatedGlobalBy'),
    render: (value) => value?value.email:''
  },
  
  {
    name: 'externalId',
    label: i18n('entities.event.fields.externalId'),
  },  

  {
    name: 'eventHour',
    label: i18n('entities.event.fields.eventHour'),
  },  
  {
    name: 'description',
    label: i18n('entities.event.fields.description'),
  },    
  /*
  {
    name: 'eventTimeZone',
    label: i18n('entities.event.fields.eventTimeZone'),
    render: exporterRenders.relationToOne(),
  },
  */
  {
    name: 'category',
    label: i18n('entities.event.fields.category'),
    render: (value) => value ? value.name : '',
  }, 
  {
    name: 'country',
    label: i18n('entities.event.fields.country'),
    render: (value) => value ? value.name : '',
  },
  {
    name: 'place',
    label: i18n('entities.event.fields.place'),
    render: (value) => value ? value.name : '',
  },
  {
    name: 'address',
    label: i18n('entities.event.fields.address'),
  }, 
  {
    name: 'classes',
    label: i18n('entities.event.fields.classes'),
    render: (value) => value.map(ic => ic.name).join(','),
  },
  {
    name: 'tags',
    label: i18n('entities.event.fields.tags'),
    render: (value) => value.map(ic => ic.tag).join(','),
  },
  {
    name: 'link',
    label: i18n('entities.event.fields.link'),
  },    
  {
    name: 'eventStatus',
    label: i18n('entities.event.fields.eventStatus'),
  },
  {
    name: 'eventSource',
    label: i18n('entities.event.fields.eventSource'),
  },
  {/*
    name: 'publicSchedule',
    label: i18n('entities.event.fields.publicSchedule'),
    render: exporterRenders.boolean(),
  */},
  {
    name: 'eventSchedule_name',
    label: i18n('entities.eventSchedule.fields.name')
  },
  
  {
    name: 'eventSchedule_from',
    label: i18n('entities.eventSchedule.fields.eventFrom'),
    render: (value) => value ? moment(value).format('YY/MM/DD') : value,
  },
  {
    name: 'eventSchedule_hour',
    label: i18n('entities.eventSchedule.fields.eventHour')
  },  
  {
    name: 'notes',
    label: i18n('entities.event.fields.notes'),
  }, 
  {
    name: 'responsableOrContact',
    label: i18n('entities.event.fields.responsableOrContact'),
    render: (value) => value?value.email:''
  },
  {
    name: 'eventContact',
    label: i18n('entities.event.fields.eventContact')
  },  
  {
    name: 'resources',
    label: i18n('entities.event.fields.resources'),
    render: exporterRenders.filesOrImages(),
  },   
  {
    name: 'mainImage',
    label: i18n('entities.event.fields.mainImage'),
    render: exporterRenders.filesOrImages(),
  },
  {
    name: 'organizerLogo',
    label: i18n('entities.event.fields.organizerLogo'),
    render: exporterRenders.filesOrImages(),
  },
  {
    name: 'mainImageExternal',
    label: i18n('entities.event.fields.mainImageExternal'),
  },
  {
    name: 'organizerLogoExternal',
    label: i18n('entities.event.fields.organizerLogoExternal'),
  },    
];
